export default __webpack_public_path__ + "static/media/ptm_bg_1.b5e1d12f.png";